import { useContext } from "react";
import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import { GenericConfigContext } from "/contexts/generic-config-context";
import { componentStyles } from "./parallex-paragraphs.scss";

const paragraphs = [
  {
    titleKey: "parallex.paragraphs.first.title",
    descriptionKey: "parallex.paragraphs.first.description",
    avatarSrc: "https://dapulse-res.cloudinary.com/image/upload/r_400/f_auto,q_auto/remote_mondaycom_static/uploads/BarBen/jane.jpeg",
    testimonialKey: "parallex.paragraphs.first.testimonial",
    name: "Jane Tham",
    jobTitleKey: "parallex.paragraphs.first.jobTitle",
    companyName: "Universal Music Group",
  },
  {
    titleKey: "parallex.paragraphs.second.title",
    descriptionKey: "parallex.paragraphs.second.description",
    avatarSrc:
      "https://dapulse-res.cloudinary.com/image/upload/r_400/f_auto,q_auto/remote_mondaycom_static/uploads/BarBen/sarah.jpeg",
    testimonialKey: "parallex.paragraphs.second.testimonial",
    name: "Sarah Pharr",
    jobTitleKey: "parallex.paragraphs.second.jobTitle",
    companyName: "Genpact"
  },
  {
    titleKey: "parallex.paragraphs.third.title",
    descriptionKey: "parallex.paragraphs.third.description",
    avatarSrc:
      "https://dapulse-res.cloudinary.com/image/upload/r_400/f_auto,q_auto/remote_mondaycom_static/uploads/BarBen/baptiste.jpeg",
    testimonialKey: "parallex.paragraphs.third.testimonial",
    name: "Baptiste Ancey",
    jobTitleKey: "parallex.paragraphs.third.jobTitle",
    companyName: "Indosuez Wealth Management"
  }
];

const ParallexParagraphs = (props) => {
  const { translate } = useContext(GenericConfigContext);

  return (
    <div className="parallex-paragraphs">
      {paragraphs.map((paragraph, index) => (
        <div key={`paragraph_${index}`} className="paragraph">
          <div className="headline">
            <FullParagraph
              title={translate(paragraph.titleKey)}
              body={translate(paragraph.descriptionKey)}
              topic={{ text: "" }}
            />
          </div>
          <div className="social-proof">
            <img className="avatar" src={paragraph.avatarSrc} />
            <div className="testimonial">
              <span>“</span>
              <div className="content">
                <span className="main">{translate(paragraph.testimonialKey)}”</span>
                <div className="person">
                  <span className="text">{paragraph.name}</span>
                  <span className="divider">|</span>
                  <span className="text">{translate(paragraph.jobTitleKey)}</span>
                </div>
                <div className="company">{paragraph.companyName}</div>
              </div>
            </div>
          </div>
        </div>
      ))}
      <style jsx>{componentStyles}</style>
    </div>
  );
};

export default ParallexParagraphs;
